import { render, staticRenderFns } from "./LineLoginButton.vue?vue&type=template&id=01895868&"
import script from "./LineLoginButton.vue?vue&type=script&lang=js&"
export * from "./LineLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./LineLoginButton.vue?vue&type=style&index=0&id=01895868&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports